export const ACTIONS = {
  STATUS: 'modal/status',
};

export const enableModal = value => ({ type: ACTIONS.STATUS, ...value });
